import type { Achievement } from "../achievement.types";

// Awarded from the atlas's `seen` count against the live graph's size:
// see ../atlasAchievements.ts.
export const halfTheMapAchievement: Achievement = {
  id: "halfTheMap",
  name: "Half the Map",
  description: "Mapped half of her mind.",
  icon: "circle-half-full",
  check: () => false,
};
